(function () {
  'use strict';

  var BUNDLE_KEY = 'luxlaria-wellness-bundle';

  function parseVariantIds(root) {
    var raw = root.getAttribute('data-variant-ids');
    if (!raw) return [];
    try {
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed.map(Number).filter(Boolean) : [];
    } catch (e) {
      return [];
    }
  }

  function cartRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function setStatus(root, message, type) {
    var el = root.querySelector('[data-lux-bundle-status]');
    if (!el) return;
    el.hidden = !message;
    el.textContent = message || '';
    el.classList.remove('is-error', 'is-success');
    if (type) el.classList.add('is-' + type);
  }

  function setLoading(btn, loading) {
    if (!btn) return;
    btn.classList.toggle('is-loading', loading);
    btn.disabled = loading;
  }

  async function fetchCartJs(root) {
    var res = await fetch(root + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) throw new Error('Could not read cart.');
    return res.json();
  }

  async function clearCart(root) {
    var cart = await fetchCartJs(root);
    if (!cart.items || !cart.items.length) return;

    var updates = {};
    cart.items.forEach(function (item) {
      updates[item.key] = 0;
    });

    var res = await fetch(root + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ updates: updates }),
    });

    if (!res.ok) {
      var clearRes = await fetch(root + 'cart/clear.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!clearRes.ok) throw new Error('Could not clear cart.');
    }
  }

  async function addWellnessBundle(root) {
    var variantIds = parseVariantIds(root).slice(0, 2);
    if (variantIds.length < 2) {
      setStatus(root, 'Bundle is unavailable right now. Please try again later.', 'error');
      return;
    }

    var eyeId = variantIds[0];
    var bottleId = variantIds[1];
    var bundleTitle = root.getAttribute('data-bundle-title') || 'Luxlaria Wellness Bundle';
    var includesLabel = root.getAttribute('data-includes-label') || '';
    var discountCode = (root.getAttribute('data-discount-code') || '').trim();
    var btn = root.querySelector('[data-lux-bundle-add]');

    if (btn && btn.dataset.luxBundleAdding === '1') return;
    if (btn) btn.dataset.luxBundleAdding = '1';

    setLoading(btn, true);
    setStatus(root, 'Adding both items to your cart…', 'success');

    var properties = {
      Bundle: bundleTitle,
      _bundle: BUNDLE_KEY,
    };
    if (includesLabel) {
      properties.Includes = includesLabel;
    }

    try {
      var rootPath = cartRoot();

      /* Bundle replaces the cart — only these two products should remain */
      await clearCart(rootPath);

      var res = await fetch(rootPath + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [
            { id: eyeId, quantity: 1, properties: properties },
            { id: bottleId, quantity: 1, properties: properties },
          ],
        }),
      });

      if (!res.ok) {
        var err = await res.json().catch(function () { return {}; });
        throw new Error(err.description || err.message || 'Could not add bundle to cart.');
      }

      document.dispatchEvent(new CustomEvent('lux:cart:updated'));

      var redirectPath = rootPath + 'cart';
      if (discountCode) {
        sessionStorage.setItem('lux-bundle-discount-pending', discountCode);
      }

      window.location.href = redirectPath;
    } catch (error) {
      if (btn) btn.dataset.luxBundleAdding = '0';
      setStatus(root, error.message || 'Something went wrong. Please try again.', 'error');
      setLoading(btn, false);
    }
  }

  function init() {
    document.querySelectorAll('[data-lux-wellness-bundle]').forEach(function (root) {
      var btn = root.querySelector('[data-lux-bundle-add]');
      if (!btn || btn.dataset.luxBundleBound) return;
      btn.dataset.luxBundleBound = '1';
      btn.addEventListener('click', function () {
        addWellnessBundle(root);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
